export default __webpack_public_path__ + "static/media/DesperateTimes.cc511f91.mp3";